<template>
    <BasePeekingCarouselModule v-bind="$props" :shoppableImageModule="ShoppableImageModule" />
</template>

<script setup>
import { markRaw, defineAsyncComponent } from 'vue';

import carouselModuleProps from '~coreModules/contentful/js/carouselModuleProps';

import BasePeekingCarouselModule from '~coreModules/contentful/components/BasePeekingCarouselModule.vue';

// NU_TODO: https://urbnit.atlassian.net/browse/TYP-26682
// Remove below when we update to vue-eslint-parser v9.0.0 or later
/* eslint-disable vue/valid-define-props */
defineProps(carouselModuleProps.props);

const ShoppableImageModule = markRaw(
    defineAsyncComponent(
        () => import(
            /* webpackChunkName: "shoppableImageModule" */
            '~modules/contentful/components/ShoppableImageModule.vue'),
    ));
</script>
